<template>
    <div class="ml-3">
        <label>Imagen Deportista</label>
        <b-img v-if="base.foto_perfil" height="300" width="300" thumbnail fluid :src="base.foto_perfil" alt="Foto de perfil" class="mb-2"></b-img>
        <label for="">Si sube una nueva imagen se cambia automaticamente</label>
        <vue-dropzone
            ref="myVueDropzone" 
            id="dropzone"
            v-on:vdropzone-success="vdropzone_success_handler"
            :options="dropzoneOptions"
        >
        </vue-dropzone>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
    props: ['base'],
    created(){
        this.dropzoneOptions["url"] = this.config.API_BASE + "/f/guardar-foto-deportista" + "?id=" + this.base.id;
    },
    data(){
        return {
            dropzoneOptions: {
                url: null,
                thumbnailWidth: 150,
                maxFilesize: 50,
                maxFiles: 1,
                uploadMultiple: false,
                dictDefaultMessage: "Arrastra aquí tu imagen",
            },
            foto: null,
        }
    },
    methods: {
        vdropzone_success_handler(file, response) {
            this.base.foto_url = response.url;
        },
    },
    components: {vueDropzone: vue2Dropzone}
}
</script>